<template>
  <div
    :class="['level', labStatus, focusedLabId === lab.id ? 'lab-focused' : '']"
  >
    <div
      :class="[
        'level__wrapper',
        'level__wrapper--lab',
        isLabFinished && 'level__wrapper--lab-finished',
      ]"
    >
      <LevelTitle :title="title" :labType="labType" :labStatus="labStatus" />
      <div class="level__details-wrapper">
        <LevelControl
          @click="toggleLab()"
          :isLoading="isLoading"
          :hasAccess="hasAccess"
          :isContentActive="false"
          :statusText="`SEE DETAILS`"
          :status="labStatus"
          :plansLink="plansLink"
          :courseStatus="courseStatus"
        />
      </div>
    </div>
    <div class="level__content">
      <LabModal v-if="labOpen" :lab="lab" @closeModal="toggleLab" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LabModal from '@/components/modals/lab-modal/LabModal.vue'
import CONSTANTS from '@/constants'
import LevelTitle from './level/LevelTitle.vue'
import LevelControl from './level/LevelControl.vue'

export default {
  name: 'LabLevel',
  data() {
    return {
      isLoading: false,
      labOpen: false,
    }
  },
  components: {
    LabModal,
    LevelTitle,
    LevelControl,
  },
  props: {
    courseId: {
      type: String,
      required: true,
    },
    courseStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    lab: {
      type: Object,
      required: true,
    },
    labStatus: {
      type: String,
      required: true,
    },
    labType: {
      type: String,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      focusedLabId: state => state.labs.focusedLabId,
    }),
    isLabFinished() {
      return (
        this.labStatus &&
        this.labStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED
      )
    },
  },
  methods: {
    async toggleLab() {
      this.labOpen = !this.labOpen
      this.$store.dispatch('content/setPlayingVideoId', '')
      this.$store.dispatch('content/setCurrentQuizId', '')
    },
  },
}
</script>
